/**
 * Pricing Configuration
 * Canonical commercial plans: Base / Pro
 */

export interface PricingPlan {
  name: string;
  subtitle: string;
  description: string;
  price: number;
  originalPrice?: number;
  currency: string;
  period: string;
  badge?: string;
  badgePrice?: number;
  features: string[];
  cta: string;
  popular: boolean;
  highlight?: string;
}

export const TRIAL_DAYS = 14;

export const PRICING_PLANS: PricingPlan[] = [
  {
    name: "Base",
    subtitle: "Decision clarity for solo B2B sales",
    description: "For individual operators who need focus, priorities, and clean daily execution.",
    price: 19.99,
    originalPrice: 29.99,
    currency: "€",
    period: "/month",
    badge: "Founder Early Access",
    badgePrice: 14.99,
    features: [
      "1 workspace",
      "1 user",
      "Up to 500 leads",
      "Today view with daily priorities",
      "Decision Engine for lead prioritization",
      "Revenue-focused analytics",
      "WhatsApp & call integration",
      "Email support",
    ],
    cta: "Start Free Trial",
    popular: false,
    highlight: "Best for solo B2B sales",
  },
  {
    name: "Pro",
    subtitle: "Revenue impact for growing teams",
    description: "For teams that need advanced prioritization, team visibility, and higher operational throughput.",
    price: 29.99,
    originalPrice: 49.99,
    currency: "€",
    period: "/month",
    features: [
      "Up to 3 workspaces",
      "Up to 10 users",
      "Unlimited leads",
      "Advanced Decision Engine",
      "Revenue impact analytics",
      "Team performance dashboard",
      "Pipeline management",
      "Priority email support",
      "CSV import/export",
    ],
    cta: "Start Free Trial",
    popular: true,
    highlight: "Best for growing sales teams",
  },
];

export interface FeatureRow {
  category: string;
  feature: string;
  base: string | boolean;
  pro: string | boolean;
}

export const FEATURE_COMPARISON: FeatureRow[] = [
  {
    category: "Decision & Focus",
    feature: "Today View with Priorities",
    base: true,
    pro: true,
  },
  {
    category: "Decision & Focus",
    feature: "Decision Engine",
    base: "Core scoring",
    pro: "Advanced AI-powered",
  },
  {
    category: "Decision & Focus",
    feature: "Lead Prioritization",
    base: true,
    pro: true,
  },
  {
    category: "Decision & Focus",
    feature: "Focus Sessions",
    base: true,
    pro: true,
  },
  {
    category: "Revenue Impact",
    feature: "Revenue Analytics",
    base: "Basic",
    pro: "Advanced with forecasting",
  },
  {
    category: "Revenue Impact",
    feature: "Pipeline Value Tracking",
    base: false,
    pro: true,
  },
  {
    category: "Revenue Impact",
    feature: "Deal Probability Scoring",
    base: "Basic",
    pro: "AI-enhanced",
  },
  {
    category: "Revenue Impact",
    feature: "Revenue Forecasting",
    base: false,
    pro: true,
  },
  {
    category: "Team & Collaboration",
    feature: "Users",
    base: "1",
    pro: "Up to 10",
  },
  {
    category: "Team & Collaboration",
    feature: "Workspaces",
    base: "1",
    pro: "Up to 3",
  },
  {
    category: "Team & Collaboration",
    feature: "Team Dashboard",
    base: false,
    pro: true,
  },
  {
    category: "Team & Collaboration",
    feature: "Performance Analytics",
    base: false,
    pro: true,
  },
  {
    category: "Data & Integration",
    feature: "Leads",
    base: "500",
    pro: "Unlimited",
  },
  {
    category: "Data & Integration",
    feature: "CSV Import/Export",
    base: false,
    pro: true,
  },
  {
    category: "Data & Integration",
    feature: "Meta Lead Ads",
    base: false,
    pro: true,
  },
  {
    category: "Security & Support",
    feature: "Support",
    base: "Email",
    pro: "Priority email",
  },
];
